import React from 'react';
import {Link, useRouteMatch} from "react-router-dom";
import * as Front from "./Front";

const current = "/~Solferino/menu";

export function BuildPage(): Page {
  return {title: "目次", path: current, parent: Front.BuildPage()};
}

export function Render(props: SolferinoProps) {
  const [rendered, setRendered] = React.useState(false);

  const isExact = useRouteMatch(current)?.isExact;
  React.useEffect(() => {
    if (isExact && !rendered) {
      setRendered(true);
      props.setPage(BuildPage());
    }
  }, [isExact, rendered, props]);

  return (
    <div className="Front">
      <p>管理人へのご連絡は情報twitter支部よりどうぞ</p>
      <ul className="group">
        <li>
          <dl className="dlTable">
            <dt><Link to={"/~Solferino/profile"}>自己紹介</Link></dt>
            <dd><span className="AA">σ(ﾟ∀ﾟ)</span></dd>
            <dt><Link to={"/~Solferino/history"}>更新履歴</Link></dt>
            <dd><span className="AA">（･∀･)つ⑩</span></dd>
            <dt><Link to={"/~Solferino/broadcasts"}>実況履歴</Link></dt>
            <dd><span className="AA">(∩ﾟдﾟ)</span></dd>
            <dt><Link to={"/~Solferino/writing"}>雑記廃物</Link></dt>
            <dd><span className="AA">φ（．．） (´ー`)ノ⌒◇</span></dd>
            <dt><Link to={"/~Solferino/board"}>掲示板等</Link></dt>
            <dd><span className="AA">（・∀・）人（・∀・）</span></dd>
            <dt><Link to={"/~Solferino/connections"}>接続状況</Link></dt>
            <dd><span className="AA">|Дﾟ)</span></dd>
            <dt><Link to={"/~Solferino/restrictions"}>規制情報</Link></dt>
            <dd><span className="AA">||Φ|(|ﾟ|∀|ﾟ|)|Φ||</span></dd>
            <dt><Link to={"/~Solferino/notes"}>諸注意等</Link></dt>
            <dd><span className="AA">(((( ；ﾟДﾟ)))</span></dd>
          </dl>
        </li>
        <li>
          <ul>
            <li><a href="http://www.youtube.com/AntennaJane">実況YouTube支部</a></li>
            <li><a href="http://www.nicovideo.jp/mylist/11220814">実況ニコニコ支部</a></li>
            <li><a href="http://www.ustream.tv/channel/antennajane-live">実況Ustream支部</a></li>
          </ul>
        </li>
        <li>
          <ul>
            <li><a href="https://twitter.com/AntennaJane">情報twitter支部</a></li>
            <li><a href="https://pawoo.net/@AntennaJane">情報Pawoo支部</a></li>
            <li><a href="https://misskey.io/@AntennaJane">情報Misskey支部</a></li>
            <li><a href="http://tokioritsukutameiki.blog65.fc2.com">情報FC2支部</a></li>
          </ul>
        </li>
        <li>
          <ul>
            <li><a href="https://www.pixiv.net/member.php?id=46097">小説pixiv支部</a></li>
            <li><a href="https://xmypage.syosetu.com/x7608t">小説ノクターン支部</a></li>
          </ul>
        </li>
      </ul>
      <address>AntennaJane 2005-01-06 作成 2026-07-25 更新</address>
    </div>
  );
}
